const query = (id, isPreview) => `{
    globalSearchListing(id: "${id}", preview: ${isPreview}){
      internalTitle
      heading
    }
  }`
  
  module.exports = { query }